import { ISession, ISessionRaw } from '@ftd/types'

import { BASE_URL } from '@/api/constants'
import { secureFetch } from '@/api/secure-fetch'

export const apiCreateSession = async (data: Partial<ISession<string>>): Promise<ISession<string>> => {
  const res = await secureFetch(`${BASE_URL}/sessions`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
  if (!res.ok) throw new Error('Failed to create session')
  return res.json()
}

export type TGetSessionsResponse = {
  docs: ISessionRaw[]
  limit: number
  skip: number
  total: number
}

export const apiGetSessions = async (skip: number, limit: number): Promise<TGetSessionsResponse> => {
  const res = await secureFetch(`${BASE_URL}/sessions?skip=${skip}&limit=${limit}`, {
    next: { revalidate: 5 },
  })
  if (!res.ok) throw new Error('Failed to fetch sessions')
  return res.json()
}

export const apiGetSessionsServer = async (
  token: string,
  skip: number,
  limit: number,
): Promise<TGetSessionsResponse> => {
  const res = await fetch(`${BASE_URL}/sessions?skip=${skip}&limit=${limit}`, {
    headers: {
      'Content-Type': 'application/json',
      token,
    },
  })
  if (!res.ok) throw new Error('Failed to fetch sessions')
  return res.json()
}

export const apiGetSession = async (id: string): Promise<ISessionRaw> => {
  const res = await secureFetch(`${BASE_URL}/sessions/${id}`)
  if (!res.ok) throw new Error('Failed to fetch session')
  return res.json()
}

export const apiUpdateSession = async (id: string, data: Partial<ISession<string>>): Promise<ISessionRaw> => {
  const res = await secureFetch(`${BASE_URL}/sessions/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
  if (!res.ok) throw new Error('Failed to update session')
  return res.json()
}

export const apiDeleteSession = async (id: string): Promise<void> => {
  const res = await secureFetch(`${BASE_URL}/sessions/${id}`, {
    method: 'DELETE',
  })
  if (!res.ok) throw new Error('Failed to delete session')
}

export const apiDuplicateSession = async (id: string): Promise<ISessionRaw> => {
  const res = await secureFetch(`${BASE_URL}/sessions/${id}/duplicate`, {
    method: 'POST',
  })
  if (!res.ok) throw new Error('Failed to duplicate session')
  return res.json()
}

export const apiFileUploadPhotos = async (id: string, photos: File[]): Promise<ISessionRaw> => {
  const formData = new FormData()
  photos.forEach((photo) => formData.append('files', photo))
  const res = await secureFetch(`${BASE_URL}/sessions/${id}/photos`, {
    method: 'PUT',
    body: formData,
  })
  if (!res.ok) throw new Error('Failed to upload photos')
  return res.json()
}

export const apiDeleteSessionPhoto = async (id: string, photoId: string): Promise<ISessionRaw> => {
  const res = await secureFetch(`${BASE_URL}/sessions/${id}/photos/${photoId}`, {
    method: 'DELETE',
  })
  if (!res.ok) throw new Error('Failed to delete photo')
  return res.json()
}

export const apiRenameSessionPhoto = async (id: string, photoId: string, name: string): Promise<ISessionRaw> => {
  const res = await secureFetch(`${BASE_URL}/sessions/${id}/photos/${photoId}/name`, {
    method: 'PUT',
    body: JSON.stringify({ customName: name }),
  })
  if (!res.ok) throw new Error('Failed to rename photo')
  return res.json()
}
